import * as mutationType from "../mutation_types";
import questionTypes from "@/helpers/enums/questionTypes";

const state = {
  userRecordId: "",
  survey: {},
  step: 0,
  is_preview: false
};

const getters = {
  survey: state => state.survey,
  step: state => state.step,
  current_step: state => (state.survey.questions || [])[state.step - 1],
  questions: state => {
    return state.survey.questions || [];
  },
  total_question_count: (state, getters) => getters.questions.length,
  completed_question_count: (state, getters) =>
    getters.questions.filter(
      x =>
        (x.value != null && (x.value.toString() || "").trim() != "") ||
        x.skipped
    ).length,
  next_step_enabled: (state, getters) =>
    !!getters.current_step.value ||
    getters.current_step.value == "0" ||
    getters.current_step.type == questionTypes.FEEDBACK,
  is_complete: state => {
    if (state.survey && state.survey.questions) {
      return state.step > state.survey.questions.length;
    }
    return false;
  },
  is_preview: state => state.is_preview,
  is_anonymous: state => state.survey.isAnonymous
};

const actions = {
  getSurvey({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      let url = "/api/survey/" + id;
      if (state.is_preview) {
        url += "?preview=true";
      }
      this._vm.$http
        .get(url)
        .then(res => {
          commit(mutationType.SET_USERRECORDID, id);
          commit(mutationType.SET_SURVEY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveSurveyAnswer({ commit, state }, answer) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/survey/" + state.userRecordId + "/answer", answer)
        .then(() => {
          commit(mutationType.SET_SURVEY_ANSWER, answer);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveSurveyFeedback({ commit, state }, feedback) {
    return new Promise((resolve, reject) => {
      if (!feedback.value) {
        resolve();
        return;
      }
      this._vm.$http
        .post("/api/survey/" + state.userRecordId + "/feedback", feedback)
        .then(() => {
          commit(mutationType.SET_SURVEY_ANSWER_FEEDBACK, feedback);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeSurvey({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/survey/" + state.userRecordId + "/complete")
        .then(() => {
          commit(mutationType.SET_NEXT_STEP);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  nextStep({ commit }) {
    commit(mutationType.SET_NEXT_STEP);
  },
  previousStep({ commit }) {
    commit(mutationType.SET_PREVIOUS_STEP);
  },
  setIsPreview({ commit }, value) {
    commit(mutationType.SET_IS_PREVIEW, value);
  }
};

const mutations = {
  [mutationType.SET_SURVEY](state, survey) {
    state.survey = survey;
    state.step = 0;
  },
  [mutationType.SET_USERRECORDID](state, id) {
    state.userRecordId = id;
  },
  [mutationType.SET_SURVEY_ANSWER](state, answer) {
    let index = state.survey.questions.findIndex(x => x.id == answer.id);
    if (index >= 0) {
      this._vm.$set(state.survey.questions[index], "value", answer.value);
    }
  },
  [mutationType.SET_NEXT_STEP](state) {
    state.step += 1;
  },
  [mutationType.SET_PREVIOUS_STEP](state) {
    state.step -= 1;
  },
  [mutationType.SET_IS_PREVIEW](state, value) {
    state.is_preview = value;
  },
  [mutationType.SET_SURVEY_ANSWER_FEEDBACK](state, feedback) {
    if (feedback.questionId) {
      let index = state.survey.questions.findIndex(
        x => x.id == feedback.questionId
      );
      if (index >= 0) {
        this._vm.$set(
          state.survey.questions[index],
          "feedback",
          feedback.value
        );
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
